import { useIntl } from 'react-intl';
import { useEffect, useState } from 'react';
import { HttpClientProvider } from '@services/http/client/http-client-provider';
import { StorieSuccesso } from '@components/home/storie-successo/storie-successo';
import { GetArticlesRemoteCall } from '@services/http/remote-calls/snf-api/articles/get-articles.http-remote-call';
import { HomeHeaderImage } from '../components/home/header-image/header-image';
import { PageHead } from '../components/common/head/page-head';
import { Navbar } from '../components/common/navbar/navbar';
// import { CounterDipendenti } from '../components/home/counter-dipendenti/counter-dipendenti'; temporary comment
import styles from './index.module.css';
import { articleType } from '../services/http/remote-calls/snf-api/articles/article.type';
import { useSiteData } from '../context/site-data-context';

export default function Home() {
  const intl = useIntl();
  const { serviceCategories, technologyCategories } = useSiteData();
  const [stories, setStories] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const httpClient = HttpClientProvider.getInstance();
      const storiesRemoteCall = new GetArticlesRemoteCall(intl.locale, [articleType.STORY], 3);
      const s = await httpClient.execute(storiesRemoteCall);
      if (!cancelled) setStories(s);
    })();
    return () => {
      cancelled = true;
    };
  }, [intl.locale]);

  return (
    <>
      <PageHead
        title={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - Home',
          description: 'Home - Page title'
        })}
        description={intl.formatMessage({
          defaultMessage:
            'Sito web di Sistemi Informativi Srl, punto di accesso a tutte le informazioni sui servizi ed i prodotti di Sistemi Informativi Srl.',
          description: 'Home - Page description'
        })}
      />
      <Navbar
        navCssClasses={styles.navbarBackground}
        navLinkCssClasses={styles.navItem}
        serviceCategories={serviceCategories}
        technologyCategories={technologyCategories}
      />
      <main role="main">
        <HomeHeaderImage />
        <StorieSuccesso stories={stories} />
        {/* <CounterDipendenti /> */}
      </main>
    </>
  );
}
